export class DataTableActionType {
  static SINGLE = 'SINGLE';
  static BATCH = 'BATCH';
  static NONE = 'NONE';
}
